import { useEffect, useRef } from 'react';
export function useButtonAboveKeyboard(buttonRef) {
  const keyboardHeight = useRef(0);

  useEffect(() => {
    const element = buttonRef.current;
    const visualViewport = window.visualViewport;

    if (!element || !visualViewport) {
      return;
    }

    const handleResize = () => {
      const newKeyboardHeight = window.innerHeight - visualViewport.height;
      keyboardHeight.current = newKeyboardHeight > 100 ? newKeyboardHeight : 0;
      if (keyboardHeight.current > 0) {
        element.classList.add('keyboard-is-open');
      } else {
        element.classList.remove('keyboard-is-open');
      }
    };

    visualViewport.addEventListener('resize', handleResize);
    return () => {
      visualViewport.removeEventListener('resize', handleResize);
    };
  }, [buttonRef]);
}
